import type { BonusItemRecord } from './types'

const STORAGE_KEY = 'erp.inventory.bonusItems.v1'

function safeParse(json: string | null): BonusItemRecord[] {
  if (!json) return []
  try {
    const parsed = JSON.parse(json)
    if (!Array.isArray(parsed)) return []
    return parsed as BonusItemRecord[]
  } catch {
    return []
  }
}

export function listBonusItems(): BonusItemRecord[] {
  return safeParse(window.localStorage.getItem(STORAGE_KEY))
}

export function getBonusItem(id: string): BonusItemRecord | undefined {
  return listBonusItems().find((r) => r.id === id)
}

export function upsertBonusItem(row: BonusItemRecord): void {
  const all = listBonusItems()
  const idx = all.findIndex((r) => r.id === row.id)
  const next = idx >= 0 ? all.map((r, i) => (i === idx ? row : r)) : [row, ...all]
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
}

export function deleteBonusItem(id: string): void {
  const all = listBonusItems().filter((r) => r.id !== id)
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(all))
}

export function nextBonusItemCode(): string {
  const n = listBonusItems().length + 1
  return `BI-${String(n).padStart(5, '0')}`
}
